import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const toastContainerConfig = {
    autoClose: 2000
};
const NotificationBox = () => _jsx(ToastContainer, Object.assign({}, toastContainerConfig));
export default NotificationBox;
